export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";